import { useformatDeadline } from "@/features/offer-cargo-destination-deadline";
import { DeliveryRouteTaskContentTags } from "@/widgets/delivery-route-task-content-tags";
import { Box, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import type { DeliveryRouteDestinationProps } from "../model";

export const DeliveryRouteDestination = (
  props: DeliveryRouteDestinationProps,
) => {
  const { t } = useTranslation();
  const { deadlineText } = useformatDeadline(props.content);
  const { deadlineText: deadlineTextDiff } = useformatDeadline(props.diff);
  return (
    <Stack spacing={1}>
      <Box>
        <Typography fontWeight={700}>{props.content.prefecture}</Typography>
        <Typography color="grey.500" fontWeight={400}>
          {props.content.address}
        </Typography>
      </Box>
      <Stack spacing={0.5}>
        <Typography fontWeight={700}>{deadlineText}</Typography>
        {deadlineTextDiff && (
          <Typography variant="body1" color="#EA583B">
            (元々の希望日時 : {deadlineTextDiff})
          </Typography>
        )}
        <DeliveryRouteTaskContentTags
          hasLoading={props.content.hasLoading ?? false}
          hasUnloading={props.content.hasUnloading ?? false}
        />
      </Stack>
      <Stack spacing={0.5}>
        <Stack direction="row" spacing={1.5}>
          <Typography
            variant="body2"
            color="grey.500"
            fontWeight={400}
            width="4em"
            whiteSpace="nowrap"
          >
            担当者
          </Typography>
          <Typography variant="body2" fontWeight={400}>
            {props.content.chargePersonName ?? "記載なし"}
          </Typography>
        </Stack>
        <Stack direction="row" spacing={1.5}>
          <Typography
            variant="body2"
            color="grey.500"
            fontWeight={400}
            width="4em"
            whiteSpace="nowrap"
          >
            連絡先
          </Typography>
          <Typography variant="body2" fontWeight={400}>
            {props.content.contactInfo ?? "記載なし"}
          </Typography>
        </Stack>
        <Stack direction="row" spacing={1.5}>
          <Typography
            variant="body2"
            color="grey.500"
            fontWeight={400}
            width="4em"
            whiteSpace="nowrap"
          >
            作業詳細
          </Typography>
          <Typography variant="body2" fontWeight={400}>
            {props.content.taskDetail
              ? t(`taskDetail.${props.content.taskDetail}`)
              : "記載なし"}
          </Typography>
        </Stack>
        <Stack direction="row" spacing={1.5}>
          <Box whiteSpace="nowrap">
            <Typography
              variant="body2"
              color="grey.500"
              fontWeight={400}
              width="4em"
            >
              特記事項
            </Typography>
            <Typography
              variant="body2"
              color="grey.500"
              fontWeight={400}
              width="4em"
            >
              (日付等)
            </Typography>
          </Box>
          <Typography variant="body2" fontWeight={400}>
            {props.content.memo ?? "記載なし"}
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};
